import {
  IconButton, Dialog, DialogTitle, DialogContent, Grid, Switch, FormControl,
  FormControlLabel, DialogActions, Container, Card, Divider, CardContent, Snackbar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import { openBlob, getUser } from 'src/utils/Common';
import CloseIcon from '@material-ui/icons/Close';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import SmsIcon from '@material-ui/icons/Sms';
import Alert from 'src/components/Alert';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import AllInboxIcon from '@material-ui/icons/AllInbox';

const useStyles = makeStyles((theme) => ({
  rootGdprPopup: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsGdpr: {
    justifyContent: 'flex-end'
  },
}));

function GdprPopup({
  open, onClose, ReceiptNo, ConsumerId, className
}) {
  const DefaultGdprValue = {
    ConsumerId: 0,
    Sms: false,
    Email: false,
    Phone: false,
    Whatsapp: false,
    SocialMedia: false,
    Message: false,
    EmployeeId: 0,
    MarketingSms: false,
    MarketingEmail: false,
    MarketingPhone: false,
    MarketingWhatsapp: false,
    MarketingSocialMedia: false,
    MarketingMessage: false,
    ThirdSms: false,
    ThirdEmail: false,
    ThirdPhone: false,
    ThirdWhatsapp: false,
    ThirdSocialMedia: false,
    ThirdMessage: false
  };

  const SessionUser = getUser();
  const [uyari, setUyari] = React.useState(false);
  const { t } = useTranslation('work_order');
  const [uyariTip, setUyariTip] = React.useState();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [GdprData, setGdprData] = useState(DefaultGdprValue);
  const [GdprPopupOpen, setGdprPopup] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  useEffect(() => {
    GetGdpr();
  }, [ReceiptNo, ConsumerId]);


  const GetGdpr = () => {
    if (ConsumerId !== undefined) {
      axios
        .get(`/GetGdprRequest/${ConsumerId}`)
        .then((response) => {
          setGdprData(response.data);
          setGdprPopup(true);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }

  };


  const SaveGdpr = () => {
    GdprData.ConsumerId = ConsumerId;
    GdprData.EmployeeId = SessionUser.TechnicianId;
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetGdprRequest', GdprData, dataConfig)
      .then((response) => {
        //onClose();
        setUyari(true);
        setGdprPopup(false);
        setUyariTip('success');
      })
      .catch((error) => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <Container maxWidth="xl" spacing={1}>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Dialog
        open={open}
        fullWidth={false}
        maxWidth="lg"
        onClose={() => { onClose(); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>


        <DialogTitle  style={{ textAlign: 'left' }}>
          {t('lblCommunicationPreferences')}
        </DialogTitle>


        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {t('lblService')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card className={classes.cards}>
            <CardContent className={classes.cardscontent}>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        checked={GdprData.Sms}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          Sms: event.target.checked
                        })}
                        name="Sms"
                      />
                    )}
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        checked={GdprData.Email}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          Email: event.target.checked
                        })}
                        name="Email"
                      />
                    )}
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        checked={GdprData.Phone}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          Phone: event.target.checked
                        })}
                        name="Phone"
                      />
                    )}
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        checked={GdprData.SocialMedia}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          SocialMedia: event.target.checked
                        })}
                        name="Phone"
                      />
                    )}
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        checked={GdprData.Whatsapp}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          Whatsapp: event.target.checked
                        })}
                        name="Phone"
                      />
                    )}
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    < AllInboxIcon/>
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Message}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Message: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
              
            </CardContent>
          </Card>
        </Container>


        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {t('lblMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card className={classes.cards}>
            <CardContent className={classes.cardscontent}>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Sms"
                        checked={GdprData.MarketingSms}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingSms: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Email"
                        checked={GdprData.MarketingEmail}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingEmail: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.MarketingPhone}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingPhone: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.MarketingSocialMedia}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingSocialMedia: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.MarketingWhatsapp}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingWhatsapp: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    < AllInboxIcon/>
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.MarketingMessage}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          MarketingMessage: event.target.checked
                        })}
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>



        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {t('lblPartyMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card className={classes.cards}>
            <CardContent className={classes.cardscontent}>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Sms"
                        checked={GdprData.ThirdSms}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdSms: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Email"
                        checked={GdprData.ThirdEmail}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdEmail: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.ThirdPhone}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdPhone: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.ThirdSocialMedia}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdSocialMedia: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={(
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.ThirdWhatsapp}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdWhatsapp: event.target.checked
                        })}
                      />
                    )}
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <IconButton>
                    < AllInboxIcon/>
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Phone"
                        checked={GdprData.ThirdMessage}
                        onChange={(event) => setGdprData({
                          ...GdprData,
                          ThirdMessage: event.target.checked
                        })}
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>


        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => setGdprPopup(false)}
            aria-label="upload picture"
            component="span"
          />
        </DialogActions>
        <DialogActions>
          <IconButton
            color="primary"
            aria-label="save"
            onClick={() => SaveGdpr()}
            component="span"
          >
            <SaveOutlinedIcon />
          </IconButton>
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="span"
            onClick={() => { onClose(); setUyari(false); }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Container>

  );
}

GdprPopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default GdprPopup;
